import React from 'react';
import './TermsDescriptions.css';


function TermsDescriptions() {
  return (
    <div className="about-descriptions-container">
      <div className="about-descriptions-placing">
        <span className="about-descriptions-title">Terms and Conditionss</span>
        <p className="about-descriptions-paragraph">
         Welcome to *BeyondSchools Online Learning Platform*! By using our platform, you agree to the following terms:
        </p>


        <span className="about-descriptions-sub-title">1. Who Can Use the Platform?</span>
        <p className="about-descriptions-paragraph-min">
        • The platform is for secondary school students, parents, teachers, and schools in Tanzania.
        </p>
        <p className="about-descriptions-paragraph-min">
           • Users under 18 must have parental consent.
        </p>

               <span className="about-descriptions-sub-title">2. Your Responsibilities</span>
        <p className="about-descriptions-paragraph-min">
              • Use the platform only for educational purposes.
        </p>
        <p className="about-descriptions-paragraph-min">
              • Keep your account secure and report any unauthorized access.
        </p>
        <p className="about-descriptions-paragraph-min">
              • Respect others and avoid harmful or inappropriate behavior.
        </p>
        
        <span className="about-descriptions-sub-title">3. Prohibited Activities</span>
        <p className="about-descriptions-paragraph-min">
        • Do not share your account, upload harmful content, or disrupt the platform.
        </p>
        <p className="about-descriptions-paragraph-min">
        • Commercial use, hacking, or illegal activities are not allowed.
        </p>
        

        <span className="about-descriptions-sub-title">4. Ownership of Content</span>
        <p className="about-descriptions-paragraph-min">
        • All platform content (text, videos, graphics) is owned by BeyondSchools or its partners.
        </p>
        <p className="about-descriptions-paragraph-min">
        • You may only use the content for personal, non-commercial, and educational purposes.
        </p>

        <span className="about-descriptions-sub-title">5. Privacy and Data</span>
        <p className="about-descriptions-paragraph-min">
        • We collect and use your data as outlined in our *Privacy Policy*.
        </p>
        <p className="about-descriptions-paragraph-min">
        • We comply with Tanzanian data protection laws.
        </p>

        <span className="about-descriptions-sub-title">6. Fees and Payments</span>
        <p className="about-descriptions-paragraph-min">
        • Some features may require payment. Fees are non-refundable unless stated otherwise.
        </p>

        <span className="about-descriptions-sub-title">7. Termination</span>
        <p className="about-descriptions-paragraph-min">
        • We may suspend or terminate accounts for violations of these terms.
        </p>
        <p className="about-descriptions-paragraph-min">
        • You can terminate your account by contacting our support team.
        </p>

        <span className="about-descriptions-sub-title">8. Limitation of Liability</span>
        <p className="about-descriptions-paragraph-min">
        • The platform is provided "as is." We are not liable for errors, interruptions, or damages arising from its use.
        </p>
     

        <span className="about-descriptions-sub-title">9. Changes to Terms</span>
        <p className="about-descriptions-paragraph-min">
        • We may update these terms. Continued use means you accept the changes.
        </p>

        <span className="about-descriptions-sub-title">9. Changes to Terms</span>
        <p className="about-descriptions-paragraph-min">
        • These terms are governed by Tanzanian law. Disputes will be resolved in Tanzanian courts.
        </p>
      </div>
    </div>
  );
}

export default TermsDescriptions;
